// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getDatabase, onValue, set, ref, remove, update } from "firebase/database";
import { uid } from "uid";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey:             process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain:         process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId:          process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket:      process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId:  process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId:              process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId:      process.env.REACT_APP_FIREBASE_MEASUMENT_ID,
  databaseURL:        process.env.REACT_APP_FIREBASE_DATABASE_URL
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const database = getDatabase(app);
let oldData = false

const readProductsFromDB = (callBack) =>{
  
  if(oldData === false)
    onValue(ref(database), snapshot=>{
      const data = snapshot.val()
      if(data !== null){
        console.log('reading')
        oldData = data
        callBack(data)
      }
    })
  else{
    console.log('returning old data')
    callBack(oldData)
  }

}

const writeProductToDB = (newProduct) =>{
  console.log('writing')
  const idUid = uid()
  newProduct['uid'] = idUid
  set(ref(database,`/${idUid}`),newProduct)
  oldData = false
}

const deleteProductFromDB = (uid) =>{
  remove(ref(database, `/${uid}`))
}
const updateProductFromDB = (uid,product)=>{
  update(ref(database, `/${uid}`), product)
  oldData = false
}
export {
  readProductsFromDB,
  writeProductToDB,
  deleteProductFromDB,
  updateProductFromDB
}